import { render, staticRenderFns } from "./AppMediaIcon.vue?vue&type=template&id=80e01d4e"
import script from "./AppMediaIcon.vue?vue&type=script&lang=js"
export * from "./AppMediaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports